<template>
  <div class="overview -page">
    <!-- todo REMOVE THIS SHIT -->
    <h2>Settings</h2>
    <p>soon..</p>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("app", ["users", "roles", "directions", "users_list"])
  },
  methods: {
    ...mapActions("app", ["getUsersList"])
  },
  async beforeMount() {
    await this.getUsersList();
  }
};
</script>
